



















































































































































































































































































































































































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { CompanyEmployee } from '@/model/company/CompanyEmployee'
import { Department } from '@/model/companyStructure/Department'
import { Employee } from '@/model/companyStructure/Employee'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import Password from './employee-form/Password.vue'
import Capacity from './employee-form/Capacity.vue'
import CostCenter from './employee-form/CostCenter.vue'
import Qcq from './employee-form/Qcq.vue'
import {
  CHANGE_EMPLOYEE_DATA, COMPANY_FETCH_COMPANY_STRUCTURE,
  FETCH_EMPLOYEE_PHOTO,
  SEARCH_ADDRESS_BY_ID,
  SEARCH_ADDRESS_LIST,
  UPSERT_EMPLOYEE, UPSERT_EMPLOYEE_CONTACTS
} from '@/store/action-types'
import { EmployeeDataPayload, UpsertMitarbeiterKontaktinfosRequest, UpsertMitarbeiterRequest } from '@/types/payload'
import UpdatePhotoDialog from '@/components/employee-form/UpdatePhotoDialog.vue'
import { School } from '@/model/companyStructure/School'
import EmployeeAdditionalFields from '@/components/additional-fields/EmployeeAdditionalFields.vue'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'
import { EmployeeMetadataResponseItem, UpdateEmployeeResponse } from '@/types/service-response'
import Documents from '@/components/Documents.vue'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import EmployeeTreeFilterDialog from '@/components/employee-form/EmployeeTreeFilterDialog.vue'
import { generateUuid } from '@/services/uuid-service'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { SidebarItem, UiLanguageList } from '@/types'
import NumberField from '@/components/NumberField.vue'
import { Address } from '@/model/planning/Address'

interface ComponentData {
  rules: Array<Function>
  activeTab: number
  departmentSelectionList: Array<number>
  showSuccessSnackbar: boolean
  showErrorSnackbar: boolean
  errorMessage: string
  showUpdatePhotoDialog: boolean
  photoData: string | undefined
  photoRemove: boolean
  photoUpdate: boolean

  tableHeight: string
  saveLoading: boolean

  employeePhoto: string | null
  showTreeFilter: boolean
  treeFilterData: any[]
  selectedTreeFilterItem: any | null
  givenName: string
  familyName: string
  position: string
  nickName: string
  shortName: string
  personalNumber: string
  mobilePhone: string
  email: string
  businessEmail: string
  phone: string
  phonePlus: string
  skype: string
  isPlanable: boolean
  SYZInTimeAktiv: boolean
  isFloater: boolean
  isApprentice: boolean
  selectedPlanningGroup: number | null
  selectedSchool: number | null
  status: number | null
  selectedSupervisor: number | null
  workplace: string
  entryDate: string
  entryDateFormatted: string | null
  birthDate: string
  birthDateFormatted: string | null
  levelOfEmployment: number | null
  selectedReplacement: number | null
  placeOfResidence: string
  exitDate: string
  exitDateFormatted: string | null
  nationality: any | null
  anrede: number | null
  anmeldungen: number
  uiSprache: number | null
  druckGruppe: number | null
  privatAdresse: Address | null
  search: string | null
  selected: boolean
  addressList: Array<Address>
  isLoading: boolean
  contactInfoList: any[]
  employeeId: number | null

  menu1: boolean
  menu2: boolean
  menu3: boolean
  dateRules: any[]
  nullableDateRules: any[]

}

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface PlaningGroupItem {
  id: number
  name: string
}
interface SelectedDepartments {
  abteilungId: number
}

export default Vue.extend({
  name: 'EmployeeForm',

  components: {
    EmployeeTreeFilterDialog,
    Password,
    Capacity,
    CostCenter,
    Qcq,
    UpdatePhotoDialog,
    EmployeeAdditionalFields,
    Documents,
    NumberField
  },

  props: {
    lohnIntegration: Boolean,

    isEdit: Boolean,

    employeeItem: {
      type: Object as () => CompanyEmployee | undefined
    },

    profitCenterList: {
      type: Array as () => Array<ProfitCenter>
    },

    departmentList: {
      type: Array as () => Array<Department>
    },

    planningGroupList: {
      type: Array as () => Array<PlanningGroup>
    },

    employeeList: {
      type: Array as () => Array<Employee>
    },

    employeePhotoUrl: {
      type: String
    },

    schoolList: {
      type: Array as () => Array<School>
    },

    employeeMetaData: {
      type: Object as () => EmployeeMetadataResponseItem | null
    }
  },

  data (): ComponentData {
    return {
      rules: [(value: any): boolean | string => !!value || ''],
      activeTab: 0,
      departmentSelectionList: [],
      showSuccessSnackbar: false,
      showErrorSnackbar: false,
      errorMessage: '',
      showUpdatePhotoDialog: false,
      photoData: undefined,
      photoRemove: false,
      photoUpdate: false,

      tableHeight: '',
      saveLoading: false,

      employeePhoto: null,
      showTreeFilter: false,
      treeFilterData: [],
      selectedTreeFilterItem: null,
      givenName: '',
      familyName: '',
      position: '',
      nickName: '',
      shortName: '',
      personalNumber: '',
      mobilePhone: '',
      email: '',
      businessEmail: '',
      phone: '',
      phonePlus: '',
      skype: '',
      isPlanable: false,
      SYZInTimeAktiv: false,
      isFloater: false,
      isApprentice: false,
      selectedPlanningGroup: null,
      selectedSchool: null,
      status: null,
      selectedSupervisor: null,
      workplace: '',
      entryDate: '',
      entryDateFormatted: '',
      birthDate: '',
      birthDateFormatted: '',
      levelOfEmployment: 0,
      selectedReplacement: null,
      placeOfResidence: '',
      exitDate: '',
      exitDateFormatted: '',
      nationality: null,
      anrede: null,
      anmeldungen: 0,
      uiSprache: null,
      druckGruppe: null,
      privatAdresse: null,
      search: null,
      selected: false,
      addressList: [],
      isLoading: false,
      contactInfoList: [],
      employeeId: null,

      menu1: false,
      menu2: false,
      menu3: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        }
      ],
      nullableDateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        }
      ],
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    filteredDepartmentList (): Array<Department> {
      if(this.employeeItem && this.employeeItem.departmentId) {
        return this.departmentList.filter((item: Department) => item.id !== this.employeeItem!.departmentId)
      }  else if(this.selectedTreeFilterItem && this.selectedTreeFilterItem.oid) {
        return this.departmentList.filter((item: Department) => item.id !== this.selectedTreeFilterItem.oid)
      } else {
        return this.departmentList
      }
    },

    planningGroup (): Array<PlaningGroupItem> {
      if(this.employeeItem && this.employeeItem.departmentId) {
        const items: Array<PlaningGroupItem> = []

        let foundItem: Department | undefined = this.departmentList.find((i: Department) => this.employeeItem!.departmentId === i.id)

        this.planningGroupList.forEach((i: PlanningGroup) => {
          if (foundItem && this.employeeItem!.departmentId === i.department) {
            const name: string = foundItem.PCABTLabel + ' / ' + i.planningGroupName
            items.push({ id: i.planningGroup, name: name })
          }
        })
        return items
      } else if(this.selectedTreeFilterItem && this.selectedTreeFilterItem.oid) {
        const items: Array<PlaningGroupItem> = []

        let foundItem: Department | undefined = this.departmentList.find((i: Department) => this.selectedTreeFilterItem.oid === i.id)

        this.planningGroupList.forEach((i: PlanningGroup) => {
          if (foundItem && this.selectedTreeFilterItem.oid === i.department) {
            const name: string = foundItem.PCABTLabel + ' / ' + i.planningGroupName
            items.push({ id: i.planningGroup, name: name })
          }
        })
        return items
      } else {
        const items: Array<PlaningGroupItem> = []

        this.planningGroupList.forEach((i: PlanningGroup) => {
          items.push({ id: i.planningGroup, name: i.planningGroupName })
        })
        return items
      }
    },

    getEmployeeTitle (): string {
      if(this.employeeItem && (this.employeeItem.shortName || this.employeeItem.givenName || this.employeeItem.familyName || this.employeeItem.personalNumber)) {
        return `${this.employeeItem.shortName ? this.employeeItem.shortName : ''} / ${this.employeeItem.givenName ? this.employeeItem.givenName : ''} ${this.employeeItem.familyName ? this.employeeItem.familyName : ''} (${this.employeeItem.personalNumber ? this.employeeItem.personalNumber : ''})`
      } else {
        return ''
      }
    },

    showPasswordTab (): boolean {
      return securityService.isVisible(SecurityArea.Employee, SecurityComponent.Password)
    },

    isDisabledPasswordTab (): boolean {
      return securityService.isDisabled(SecurityArea.Employee, SecurityComponent.Password)
    },

    foundAddressList (): Array<Address> {
      return this.addressList
    },

    getAnredeList (): any[] {
      return this.employeeMetaData ? _.orderBy(this.employeeMetaData.Anreden, 'Bezeichnung') : []
    },

    getLaenderList (): any[] {
      return this.employeeMetaData ? _.orderBy(this.employeeMetaData.Laender, 'Bezeichnung') : []
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },
  },

  watch: {
    activeTab (newVal: number): void {
      this.$emit('changeActiveTab', newVal)
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 200)
    },

    employeeItem (newVal: CompanyEmployee): void {
      this.setData()
      setTimeout(() => { this.onResize() }, 0)

      this.initDepartmentSelectionList()
      if (newVal) {
        this.activeTab = 0
      }
      this.fetchPhoto()

      if(!newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    isEdit(newVal: boolean): void {
      if(newVal) {
        this.activeTab = 0
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 100)
      }
    },

    search (newVal: string | null): void {
      if (this.isLoading) return

      if(newVal && newVal.length > 2 && !this.selected) {
        this.searchAddress()
      }

      this.selected = false

      if (newVal === null || newVal && newVal.length === 0) {
        this.privatAdresse = null
        this.selected = false
      }
    },

    entryDateFormatted (newVal: string | null): void {
      if(newVal) {
        this.entryDate = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.entryDate = ''
      }
    },

    birthDateFormatted (newVal: string | null): void {
      if(newVal) {
        this.birthDate = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.birthDate = ''
      }
    },

    exitDateFormatted (newVal: string | null): void {
      if(newVal) {
        this.exitDate = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.exitDate = ''
      }
    },
  },

  methods: {
    getContactLabel (wert: number): string {
      const foundItem: any | undefined = this.contactInfoList.find((item: any) => item.Wert === wert)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    onCancelClick (): void {
      this.setData()
      this.$emit('cancel')
    },

    onEntryDateChange (date: string): void {
      this.entryDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurEntryDate (): void {
      this.entryDateFormatted = moment(this.entryDate).isValid() ?  moment(this.entryDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu3) {
          this.menu3 = false
        }
      }, 100)
    },

    onBirthDateChange (date: string): void {
      this.birthDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurBirthDate (): void {
      this.birthDateFormatted = moment(this.birthDate).isValid() ?  moment(this.birthDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onExitDateChange (date: string): void {
      this.exitDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurExitDate (): void {
      this.exitDateFormatted = moment(this.exitDate).isValid() ?  moment(this.exitDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onAnmeldungenChange (): void {
      if(this.anmeldungen == null || this.anmeldungen < 0) {
        this.anmeldungen = 0
      }
    },

    onLevelOfEmploymentChange (): void {
      if(this.levelOfEmployment == null || this.levelOfEmployment < 0) {
        this.levelOfEmployment = 0
      }
    },

    onAddressSelect (): void {
      this.selected = true
    },

    onSaveButtonClick (): void {
      //@ts-ignore
      if(this.$refs['form'].validate()) {
        if(this.lohnIntegration) {
          this.saveEmployeeAnotherData(false)
        } else {
          this.saveEmployeeData()
        }
      }
    },

    onTreeFilterClear (): void {
      this.selectedTreeFilterItem = null
    },

    onTreeFilterClick (): void {
      this.showTreeFilter = true
    },

    onTreeFilterSave (item: any): void {
      this.selectedTreeFilterItem = item
      this.showTreeFilter = false
    },

    onTreeFilterClose (): void {
      this.showTreeFilter = false
    },


    async saveEmployeeAnotherData (isSecondUpdate: boolean): Promise<void> {
      if (!isSecondUpdate && this.employeeItem || isSecondUpdate && this.employeeId) {
        let selectedDepartments: Array<SelectedDepartments> = []
        this.departmentSelectionList.forEach((item: number) => {
          selectedDepartments.push({abteilungId: item})
        })
        let allDepartments: Array<SelectedDepartments> = []
        if(this.employeeItem && this.employeeItem.isFloater && this.departmentSelectionList.length === 0 || this.isFloater && this.departmentSelectionList.length === 0) {
          allDepartments = this.filteredDepartmentList.map((item: Department) => {
            return {abteilungId: item.id}
          })
        }
        let payload: EmployeeDataPayload = {
          id: isSecondUpdate ? this.employeeId! : this.employeeItem!.id,
          isPlanable: isSecondUpdate ? this.isPlanable : this.isPlanable,
          isFloater: isSecondUpdate ? this.isFloater : this.isFloater,
          position:  isSecondUpdate ? this.position : this.position,
          planningGroupId: this.selectedPlanningGroup,
          replacementOfEmployeeId: isSecondUpdate ? this.selectedReplacement : this.selectedReplacement || null,
          supervisorId: isSecondUpdate ? this.selectedSupervisor : this.selectedSupervisor || null,
          nickName: isSecondUpdate ? this.nickName : this.nickName || '',
          preferredLanguageId: isSecondUpdate ? this.uiSprache! : this.employeeItem!.preferredLanguageId,
          allDepartments: allDepartments,
          floaterDepartments: selectedDepartments,
          photoData: this.photoData,
          photoRemove: this.photoRemove,
          photoUpdate: this.photoUpdate,
          isApprentice: isSecondUpdate ? this.isApprentice : this.isApprentice,
          schoolIn: isSecondUpdate ? this.selectedSchool : this.selectedSchool || null,
          SYZInTimeAktiv: isSecondUpdate ? this.SYZInTimeAktiv : this.SYZInTimeAktiv,
          shortName: isSecondUpdate ? this.shortName : this.shortName,
          businessEmail: isSecondUpdate ? this.businessEmail : this.businessEmail || ''
        }

        try {
          this.saveLoading = true
          const response: UpdateEmployeeResponse = await this.$store.dispatch(CHANGE_EMPLOYEE_DATA, payload)
          this.saveLoading = false
          if(response && !response.IsError) {
            if(!isSecondUpdate) {
              this.$emit('refreshEmployee')
            }
            this.showSuccessSnackbar = true
            this.photoData = undefined
            this.photoUpdate = false
            this.photoRemove = false
            this.fetchPhoto()
          } else {
            if(response && response.DuplicatedKurzzeichen) {
              this.errorMessage = this.$t('employeeFormComponent.duplicateAbbreviation').toString()
              this.showErrorSnackbar = true
            } else {
              this.errorMessage = this.$t('employeeFormComponent.changesCouldNotBeSaved').toString()
              this.showErrorSnackbar = true
            }
          }
        } catch (e) {
          this.errorMessage = this.$t('employeeFormComponent.changesCouldNotBeSaved').toString()
          this.showErrorSnackbar = true
          this.saveLoading = false
        }
      }
    },

    async saveEmployeeData (): Promise<void> {
        const foundPlanungGroup: PlanningGroup | undefined = this.selectedPlanningGroup ? this.planningGroupList.find((item: PlanningGroup) => item.id === this.selectedPlanningGroup!) : undefined

        let payload: UpsertMitarbeiterRequest = {
          ID: this.employeeItem ? this.employeeItem.id : null,
          Kurzzeichen: this.shortName,
          PersonalNummer: this.personalNumber,
          Anrede: this.anrede,
          Vorname: this.givenName,
          Name: this.familyName,
          Status: this.status,
          EintrittDatum: this.entryDate && this.entryDate.length > 0 ? this.entryDate : moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          AustrittDatum: this.exitDate && this.exitDate.length > 0 ? this.exitDate : moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          Anmeldungen: this.anmeldungen,
          UISprache: this.uiSprache!,
          DruckGruppe: this.druckGruppe,
          Arbeitsort: this.workplace,
          Nickname: this.nickName,
          Stellung: this.position,
          Vorgesetzter: this.selectedSupervisor,
          Planungsgruppe: this.selectedPlanningGroup,
          Planbar: this.isPlanable,
          Springer: this.isFloater,
          Stellvertretung: this.selectedReplacement,
          Lernender: this.isApprentice,
          SchuleIn: this.selectedSchool ? this.selectedSchool.toString() : '',
          BG: this.levelOfEmployment,
          Wohnort: this.placeOfResidence,
          PlanungColor: foundPlanungGroup ? foundPlanungGroup.color : '',
          Geburtsdatum: this.birthDate && this.birthDate.length > 0 ? this.birthDate : moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          PrivatAdresse: this.privatAdresse ? this.privatAdresse.id : null,
          Land: this.nationality ? `${this.nationality.Code} - ${this.nationality.Bezeichnung}` : '',
          SYZInTimeAktiv: this.SYZInTimeAktiv,
          Abteilung: this.selectedTreeFilterItem.oid
        }

        try {
          this.saveLoading = true
          const response: any = await this.$store.dispatch(UPSERT_EMPLOYEE, payload)
          this.saveLoading = false
          if(response && !response.IsError && response.mitarbeiterId) {
            this.employeeId = response.mitarbeiterId
            this.showSuccessSnackbar = true
            await this.saveEmployeeAnotherData(true)
            let promisesList: Promise<void>[] = []
            this.contactInfoList.forEach((item: any) => {
              let value: string = ''
              if(item.Wert === 1) {
                value = this.phone
              } else if(item.Wert === 2) {
                value = this.skype
              } else if(item.Wert === 3) {
                value = this.email
              } else if(item.Wert === 4) {
                value = this.mobilePhone
              } else if(item.Wert === 5) {
                value = this.phonePlus
              } else if(item.Wert === 6) {
                value = this.businessEmail
              }

              promisesList.push(
                this.upsertEmployeeContactInfos( {
                  ID: null,
                  Mitarbeiter: this.employeeId ? this.employeeId : this.employeeItem!.id,
                  KontaktArt: item.Wert,
                  KontaktInfo: value
                })
              )
            })

            await Promise.all(promisesList)
          } else {
            if(response && response.DuplicatedKurzzeichen) {
              this.errorMessage = this.$t('employeeFormComponent.duplicateAbbreviation').toString()
              this.showErrorSnackbar = true
            } else {
              this.errorMessage = this.$t('employeeFormComponent.changesCouldNotBeSaved').toString()
              this.showErrorSnackbar = true
            }
          }
        } catch (e) {
          this.errorMessage = this.$t('employeeFormComponent.changesCouldNotBeSaved').toString()
          this.showErrorSnackbar = true
          this.saveLoading = false
        } finally {
          if(!this.employeeItem && this.employeeId) {
            const newEmployee: SidebarItem = {
              active: true,
              category: "Employee",
              children: [],
              config: {},
              icon: "perm_identity",
              id: this.employeeId.toString(),
              route: `/employee-detail/${this.selectedTreeFilterItem.oid}/${this.employeeId}`,
              text: `${this.givenName} ${this.familyName}`
            }
            await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
            if(this.$store.state.sidebar && this.$store.state.sidebar.children) {
              const foundItem: SidebarItem | undefined = this.$store.state.sidebar.children.find((item: SidebarItem) => item.id === 'esoft2')
              if(foundItem && foundItem.children) {
                const foundItem2: SidebarItem | undefined = foundItem.children.find((item2: SidebarItem) => item2.id === 'esoft2.1')
                if(foundItem2 && foundItem2.children) {
                  const foundItem3: SidebarItem | undefined = foundItem2.children.find((item3: SidebarItem) => item3.id === this.selectedTreeFilterItem.pid.toString())
                  if(foundItem3 && foundItem3.children) {
                    const foundItem4: SidebarItem | undefined = foundItem3.children.find((item4: SidebarItem) => item4.id === this.selectedTreeFilterItem.oid.toString())
                   if(foundItem4 && foundItem4.children) {
                     foundItem4.children.push(newEmployee)
                     foundItem4.children = _.orderBy(foundItem4.children, 'text')
                   }
                  }
                }
              }
            }
            this.$router.push({ path: `/employee-detail/${this.selectedTreeFilterItem.oid}/${this.employeeId}` })
          } else {
            this.$emit('refreshEmployee')
          }
        }
    },

    async upsertEmployeeContactInfos (payload: UpsertMitarbeiterKontaktinfosRequest): Promise<void> {
      try {
        this.saveLoading = true
        await this.$store.dispatch(UPSERT_EMPLOYEE_CONTACTS, payload)
        this.saveLoading = false
      } catch (e) {
        this.errorMessage = this.$t('employeeFormComponent.changesCouldNotBeSaved').toString()
        this.showErrorSnackbar = true
        this.saveLoading = false
      }
    },

    onPhotoClick (): void {
      if(!this.employeeItem || this.employeeItem && this.isEdit) {
        this.showUpdatePhotoDialog = true
      }
    },

    onCloseUpdatePhotoDialogClick (): void {
      this.showUpdatePhotoDialog = false
    },

    onPhotoUpdateClick (): void {
      this.showUpdatePhotoDialog = false
      // @ts-ignore
      this.$refs.photoInput.click()
    },

    onPhotoRemoveClick (): void {
      this.showUpdatePhotoDialog = false
      this.photoRemove = true
      this.photoUpdate = true
    },

    onPhotoChange(e: EventFile): void {
      if (e && e.target.files) {
        const files: File | undefined = e.target.files[0]

        if (files) {
          const reader = new FileReader()

          reader.readAsDataURL(files)
          reader.onload = (e: any) => {
            if (e.target) {

              const img = new Image()
              // @ts-ignore
              img.src = e.target.result
              img.onload = () => {
                const elem = document.createElement('canvas')
                const scaleFactor = 200 / img.width
                elem.width = 200
                elem.height = img.height * scaleFactor
                const ctx = elem.getContext('2d')

                ctx!.drawImage(img, 0, 0, 200, img.height * scaleFactor)
                ctx!.canvas.toBlob((blob: any) => {
                  new File([blob], 'image', {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                  })
                }, 'image/jpeg')
                this.photoData = elem.toDataURL('image/jpeg')
                if(this.photoData) {
                  this.photoUpdate = true
                }
              }
            }
          }
        }
      }
    },

    onApprenticeChange(item: boolean): void {
      if(!item) {
        this.selectedSchool = null
      }
    },

    initDepartmentSelectionList (): void {
      if (this.employeeItem) {
        this.departmentSelectionList = this.employeeItem.floaterDepartments
        //this.departmentSelectionList = [this.employeeItem.departmentId]
      } else {
        this.departmentSelectionList = []
      }
    },

    async fetchPhoto (): Promise<void> {
      try {
        this.employeePhoto = await this.$store.dispatch(FETCH_EMPLOYEE_PHOTO, this.employeeItem!.id)
      } catch (e) {
        this.employeePhoto = null
      }
    },

    setData(): void {
      if(this.employeeMetaData && this.employeeMetaData.CodelisteMAKART) {
        const contactData: any[] = this.employeeMetaData.CodelisteMAKART.map((item: any) => {
          item.Contact = ''
          return item
        })
        this.contactInfoList = _.orderBy(contactData, 'Position')
      } else {
        this.contactInfoList = []
      }

      if(this.employeeItem) {
        this.treeFilterData.forEach((item: any) => {
          if(item.oid === this.employeeItem!.profitCenterId) {
          const foundItem: any | undefined = item.children.find((i: any) => i.oid === this.employeeItem!.departmentId)
            this.selectedTreeFilterItem = foundItem ? foundItem : null
          }
        })
        const foundAnrede: any | undefined = this.getAnredeList.find((item: any) => item.Bezeichnung === this.employeeItem!.salutation)
        const foundNationality: any | undefined = this.getLaenderList.find((item: any) => `${item.Code} - ${item.Bezeichnung}` === this.employeeItem!.nationality)

        if(this.employeeItem.privatAdresse) {
          this.searchAddressById(this.employeeItem.privatAdresse)
        }

        this.fetchPhoto()
        this.anrede = foundAnrede ? foundAnrede.ID : null
        this.givenName = this.employeeItem.givenName
        this.familyName = this.employeeItem.familyName
        this.position = this.employeeItem.position
        this.nickName = this.employeeItem.nickName
        this.shortName = this.employeeItem.shortName
        this.personalNumber = this.employeeItem.personalNumber
        this.mobilePhone = this.employeeItem.mobilePhone ? this.employeeItem.mobilePhone : ''
        this.email = this.employeeItem.email ? this.employeeItem.email : ''
        this.businessEmail = this.employeeItem.businessEmail ? this.employeeItem.businessEmail : ''
        this.phone = this.employeeItem.phone ? this.employeeItem.phone : ''
        this.phonePlus = this.employeeItem.phonePlus ? this.employeeItem.phonePlus : ''
        this.skype = this.employeeItem.skype ? this.employeeItem.skype : ''
        this.isPlanable = this.employeeItem.isPlanable
        this.SYZInTimeAktiv = this.employeeItem.SYZInTimeAktiv
        this.isFloater = this.employeeItem.isFloater
        this.isApprentice = this.employeeItem.isApprentice
        this.selectedPlanningGroup = this.employeeItem.planningGroupId
        this.selectedSchool = this.employeeItem.schoolIn
        this.status = this.employeeItem.status
        this.selectedSupervisor = this.employeeItem.supervisorId
        this.workplace = this.employeeItem.workplace
        this.entryDate = this.employeeItem.entryDate ? this.employeeItem.entryDate : ''
        this.entryDateFormatted = this.entryDate.length > 0 ? this.entryDateFormatted = moment(this.entryDate).format('DD.MM.YYYY') : ''
        this.birthDate = this.employeeItem.birthDate ? this.employeeItem.birthDate : ''
        this.birthDateFormatted = this.birthDate.length > 0 ? this.birthDateFormatted = moment(this.birthDate).format('DD.MM.YYYY') : ''
        this.levelOfEmployment = this.employeeItem.levelOfEmployment ? this.employeeItem.levelOfEmployment : 0
        this.selectedReplacement = this.employeeItem.replacementOfEmployeeId
        this.placeOfResidence = this.employeeItem.placeOfResidence ? this.employeeItem.placeOfResidence : ''
        this.exitDate = this.employeeItem.exitDate ? this.employeeItem.exitDate : ''
        this.exitDateFormatted = this.exitDate.length > 0 ? this.exitDateFormatted = moment(this.exitDate).format('DD.MM.YYYY') : ''
        this.nationality = foundNationality ? foundNationality : null
        this.uiSprache = this.employeeItem.preferredLanguageId
        this.anmeldungen = this.employeeItem.anmeldungen ? this.employeeItem.anmeldungen : 0
        this.privatAdresse = null
        this.druckGruppe = this.employeeItem.druckgruppe

      } else {
        this.departmentSelectionList = []
        this.selectedTreeFilterItem = null
        this.photoData = undefined
        this.employeePhoto = null
        this.anrede = null
        this.givenName = ''
        this.familyName = ''
        this.position = ''
        this.nickName = ''
        this.shortName = ''
        this.personalNumber = ''
        this.mobilePhone = ''
        this.email = ''
        this.businessEmail = ''
        this.phone = ''
        this.phonePlus = ''
        this.skype = ''
        this.isPlanable = false
        this.SYZInTimeAktiv = false
        this.isFloater = false
        this.isApprentice = false
        this.selectedPlanningGroup = null
        this.selectedSchool = null
        this.status = null
        this.selectedSupervisor = null
        this.workplace = ''
        this.entryDate = ''
        this.entryDateFormatted = ''
        this.birthDate = ''
        this.birthDateFormatted = ''
        this.levelOfEmployment = 0
        this.selectedReplacement = null
        this.placeOfResidence = ''
        this.exitDate = ''
        this.exitDateFormatted = ''
        this.nationality = null
        this.uiSprache = null
        this.anmeldungen = 0
        this.privatAdresse = null
        this.druckGruppe = null
      }

      const form1: any = this.$refs['form']
      form1.resetValidation()
    },

    setTreeFilterData (): void {
      this.treeFilterData = this.profitCenterList.map((item: ProfitCenter) => {
        const children: any = this.departmentList.filter((i: Department) => i.profitCenterId === item.id).map((i: Department) => {
          return {
            id: generateUuid(),
            oid: i.id,
            pid: item.id,
            name: i.label,
            type:'A',
            children: []
          }
        })

        return {
          id: generateUuid(),
          oid: item.id,
          name: item.label,
          type:'P',
          children: children
        }
      })
    },

    async searchAddressById (addressId: number): Promise<void> {
      this.isLoading = true
      try {
        const foundAddress: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_BY_ID, addressId)
        this.isLoading = false
        if(foundAddress && foundAddress[0]) {
          this.privatAdresse = foundAddress[0]
          this.addressList = [this.privatAdresse]
          this.selected = true
          this.onAddressSelect()
        }
      } catch (e) {
        this.isLoading = false
      }
    },

    async searchAddress(): Promise<void> {
      this.isLoading = true
      try {
        const data: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_LIST, this.search)
        this.addressList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },

    onResize (): void {
      const vh = window.innerHeight
      if(vh > 500) {
        this.tableHeight = `height: calc(${vh}px - 192px + ${this.employeeItem ? '0px' : '32px'}`
      } else {
        this.tableHeight = 'height: 350px'
      }
    },
  },

  mounted () {
    setTimeout(() => { this.onResize() }, 0)
    this.setTreeFilterData()
    this.initDepartmentSelectionList()

    this.setData()

    if(!this.employeeItem) {
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    }
  }
})
